import { CodeNameType } from 'components/common/types/AssetList.types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getTags } from 'modules/api/inventory';
import { formatFilterOptionsName } from 'utils/formatters';
import { FilterTagProps } from './FilterTag.types';

const FilterTag: React.FC<FilterTagProps> = ({ changeFilters, tag }) => {
  const fetchFilterOptions: AsyncSelectLoadDataHandler<CodeNameType> = async (_, query) => {
    if (query.length >= 3) {
      try {
        return await getTags(cancelFunctions, query);
      } catch (error) {
        return [];
      }
    }
    return [];
  };

  const loadFilterOptions: AsyncSelectLoadDataHandler<CodeNameType> = async (_, query) => {
    return formatFilterOptionsName(await fetchFilterOptions(_, query));
  };

  const onSelect: SelectHandler<CodeNameType> = (_, value: CodeNameType) => {
    changeFilters({ tag: value });
  };

  return (
    <AsyncSelect
      dataTestId="tag-input"
      name="tag"
      loadData={loadFilterOptions}
      onSelect={onSelect}
      placeholder="Tag"
      selectedValue={tag}
    />
  );
};

export default FilterTag;
